export default import.meta.ROLLDOWN_FILE_URL_41yqXJ7mv81Xe$0C6CBOlA